(() => {
  const heroes = document.querySelectorAll('.hero-image, .block-hero-image');

  if (!heroes.length) return;

  const heroesData = [];

  heroes.forEach((hero) => {
    const heroMask = hero.querySelector('.hero-image__mask') || hero.querySelector('.block-hero-image__mask');
    if (heroMask === null) return;

    const heroImage = hero.querySelector('.hero-image__image') || hero.querySelector('.block-hero-image__image');
    if (heroImage === null) return;

    heroesData.push({ hero, heroMask, heroImage });
  });

  const media = matchMedia('(min-width: 1024px)');
  const scalingFactor = 1.2;

  const resizeHeroes = () => {
    heroesData.forEach(({ hero, heroMask, heroImage }) => {
      const heroHeight = hero.offsetHeight;
      const maskWidth = scalingFactor * heroHeight;
      heroMask.style.height = `${maskWidth}px`;
      heroMask.style.width = `${maskWidth}px`;
      const heroMaskBounds = heroMask.getBoundingClientRect();
      const imageHeight = heroHeight;
      const imageWidth = Math.min(heroMaskBounds.width, window.innerWidth - heroMaskBounds.left);
      heroImage.style.height = `${imageHeight}px`;
      heroImage.style.width = `${imageWidth}px`;
    });
  };

  const resetHeroesSize = () => {
    heroesData.forEach(({ heroMask, heroImage }) => {
      heroMask.style.height = '';
      heroMask.style.width = '';
      heroImage.style.height = '';
      heroImage.style.width = '';
    });
  };

  const setupWindowSizeListener = () => {
    if (media.matches) {
      window.addEventListener('resize', resizeHeroes);
      resizeHeroes();
    } else {
      window.removeEventListener('resize', resizeHeroes);
      resetHeroesSize();
    }
  };

  media.addEventListener('change', setupWindowSizeListener);
  setupWindowSizeListener();
})();
